import { t } from "@/shared/lib/th-translations";

interface Props {
  namespace: string; // e.g. "production.machines.legend"
  showNoData?: boolean;
  className?: string;
}

const BANDS: Array<{ key: string; colorClass: string }> = [
  { key: "criticallyLow", colorClass: "bg-red-500 text-white" },
  { key: "low", colorClass: "bg-red-300 text-gray-900" },
  { key: "normal", colorClass: "bg-yellow-200 text-gray-900" },
  { key: "high", colorClass: "bg-green-200 text-gray-900" },
  { key: "criticallyHigh", colorClass: "bg-green-500 text-white" },
];

export default function ZScoreLegend({
  namespace,
  showNoData,
  className,
}: Props) {
  return (
    <div
      className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground ${className ?? ""}`}
    >
      <span className="font-medium">{t(`${namespace}.title`)}</span>
      <span className="italic">{t(`${namespace}.intro`)}</span>
      <div className="flex flex-wrap items-center gap-1">
        {BANDS.map((b) => (
          <span
            key={b.key}
            className={`px-2 py-0.5 rounded text-[11px] font-medium ${b.colorClass}`}
          >
            {t(`${namespace}.${b.key}`)}
          </span>
        ))}
        {showNoData && (
          <span className="px-2 py-0.5 rounded text-[11px] bg-gray-100 text-gray-600">
            {t(`${namespace}.noData`)}
          </span>
        )}
      </div>
    </div>
  );
}
